<template>
  <a-layout-content class="p-all">
    <a-row :gutter="{ xs: 0, lg: 8 }">
      <a-col :xs="24" :lg="10">
        <a-card>
          <div slot="title">
            <span class="d-block">Alokasi Pekerjaan</span>
          </div>
          <a-tag slot="extra" :color="isDrafted ? 'orange' : 'red'" v-if="mode == 'revised'">{{ isDrafted ? 'DRAFT'.toUpperCase() : mode.toUpperCase() }}</a-tag>
          <a-tag slot="extra" color="green" v-else>{{ mode.toUpperCase() }}</a-tag>
          <a-form class="m-form" :form="form">
            <a-form-item label="Periode">
              <!-- <a-input
                disabled
                v-decorator="['periode', { initialValue: initialData.periode }]"
              /> -->
              <a-row>
                <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                  <a-month-picker v-decorator="['periode', { rules: [{ required: true }], initialValue: initialPeriode }]"
                    :placeholder="'Start month'" @change="changeperiode" format="YYYY-MM" class="w-full" mode="month"
                    :allowClear="false" :disabled="listPekerjaan.length > 0" :disabled-date="disabledDate" />
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
                  <div style="width:100%;text-align:center;padding: 0px 10px 0px 10px;" v-if="lblperiode != ''"><a-tag
                      style="width:100%;padding: 4px 15px;">{{ lblperiode
                      }}</a-tag>
                  </div>
                </a-col>
              </a-row>
            </a-form-item>

            <a-form-item label=" TLC" v-if="editingfortlc">
              <a-select placeholder="ex: AAA " showSearch v-decorator="['fortlc', { rules: [{ required: true }] }]"
                :filterOption="handleFilterKaryawan" :disabled="fortlc_readonly" :v-bind="loadingkrywn">
                <a-select-option v-for="item in getKaryawan" :key="item.tlc">{{
                  item.tlc + " - " + item.nama
                }}</a-select-option>
              </a-select>
            </a-form-item>
            <!-- <a-form-item class="m-remove" label="Jenis Anggaran">
              <v-select
                class="m-select-form-half"
                :options="basedData.jenis_anggaran"
                label="text"
                :reduce="item => item.value"
                v-model="jenis_anggaran"
                @input = "changeAnggaran"
              >
              </v-select>
            </a-form-item> -->
            <a-form-item class="m-remove">
              <template slot="label">
                <font style="color:red">*</font>
                Kode Proyek
              </template>
              <v-select class="m-select-form-half" :options="projectCode" label="nama_project"
                :reduce="item => item.kode_project" v-model="kode_proyek" :loading="loadingKodeProyek"
                :disabled="this.totalPresentase === 100 && !isEdit">
              </v-select>
            </a-form-item>
            <a-form-item label="Persentase (%)">
              <a-input-number :min="0" :max="maxpercentage" :formatter="value => `${value}%`"
                :parser="value => value.replace('%', '')" :disabled="this.totalPresentase === 100 && !isEdit" v-decorator="[
                  'persentase',
                  {
                    rules: [{ required: true }],
                    initialValue: initialData.persentase
                  }
                ]" />
            </a-form-item>
            <a-form-item label="Deskripsi" :validateStatus="prefixLength.validateStatus" :help="prefixLength.errorMsg">
              <a-textarea @change="handleDescLength" placeholder="Deskripsi pekerjaan ... "
                :autoSize="{ minRows: 2, maxRows: 3 }" v-decorator="['deskripsi', { rules: [{ required: false }] }]"
                :disabled="this.totalPresentase === 100 && !isEdit" />
            </a-form-item>
          </a-form>
          <div class="m-card-footer" slot="actions">
            <a-button-group>
              <a-button v-if="!isEdit" :disabled="changeToSubmit" type="default" :loading="btnLoading.add"
                @click="handleNew('new')">{{ "Tambahkan" }}</a-button>

              <a-button v-if="!changeToSubmit && isEdit" :disabled="btnDisable" type="primary" :loading="btnLoading.save"
                @click="handleNew('edit')">{{ "Ubah Alokasi" }}</a-button>

              <a-button v-if="isEdit" type="default" @click="handleCancel">Batalkan</a-button>
            </a-button-group>
          </div>
        </a-card>
      </a-col>
      <a-col :class="isMobile ? 'm-top' : ''" :xs="24" :lg="14">
        <a-card title="List Pekerjaan" class="d-flex flex-column nowrap">
          <a-button slot="extra" type="default" :loading="modalTaskList.loadinglistTask" icon="eye"
            @click="handleViewTask">{{ "Referensi Nirmala" }}</a-button>
          <a-card v-if="totalPresentase !== 0 && totalPresentase !== 100" style="background:red!important"
            class="m-card-headline">
            <div style="text-align:center!important" :class="'d-flex justify-between align-item-center'">
              <h3 class="m-remove">
                Sisa alokasi pekerjaan : {{ 100 - totalPresentase }} %
              </h3>
              <a-icon type="exclamation-circle" :style="{ fontSize: '24px' }" />
            </div>
          </a-card>
          <b>Periode : {{ listPekerjaan[0] ? listPekerjaan[0].periode_lbl : '-' }}</b>
          <a-table :columns="table_pekerjaan.columns" :data-source="listPekerjaan" bordered :pagination="table_pekerjaan.pagination" :scroll="{ x: 1200, y: 500 }"
            :loading="table_pekerjaan.loading" size="small" key="tblMonitoring" :rowKey="(record, index) => { return index; }">
            <span slot="no" slot-scope="value, item, index" :style="item.kode_proyek=='OTHER' ? 'color:red;font-weight: bold;' : ''">
              {{ (table_pekerjaan.pagination.page - 1) * table_pekerjaan.pagination.pageSize + (index + 1) }}
            </span>
            <span slot="persentase" slot-scope="value, item, index" :style="item.kode_proyek=='OTHER' ? 'color:red;font-weight: bold;' : ''">
              {{ item.persentase }}%
            </span>
            <span slot="kode_proyek" slot-scope="value, item, index" :style="item.kode_proyek=='OTHER' ? 'color:red;font-weight: bold;' : ''">
              {{ item.kode_proyek=='OTHER' ? 'NOT_FOUND' : item.kode_proyek }}
            </span>
            <span slot="deskripsi" slot-scope="value, item, index">
              {{ item.kode_proyek=='OTHER' ? '' : item.deskripsi }}
            </span>
            <span slot="action" slot-scope="value, item, index">
              <div class="w-full">
                <a-button-group class="w-full">
                  <a-tooltip class="w-full m-tooltip-inner" placement="bottom" :title="'Ubah'">
                    <a-button block :disabled="isEdit || btnLoading.save"
                      @click="handleEdit(item)" icon="edit" type="warning"/>
                  </a-tooltip>
                  <a-tooltip class="w-full m-tooltip-inner" placement="bottom" :title="'Hapus'">
                    <a-button block :disabled="(mode == 'revised' && listPekerjaan.length == 1) || isEdit || btnLoading.save"
                      @click="handleRemove(item)" icon="close" type="danger"/>
                  </a-tooltip>
                </a-button-group>
              </div>
            </span>
          </a-table>
          <a-form-item v-if="totalPresentase == 100" label="Catatan">
            <a-textarea placeholder="Ketik catatan disini..."
              :autoSize="{ minRows: 2, maxRows: 3 }" v-model="basedData2.header[0].catatan"
              :disabled="isEdit" />
          </a-form-item>
          <div class="d-flex justify-end w-full m-top">
            <a-button-group class="m-padding-left-10">
              <a-button v-if="!isEdit" type="default" :loading="btnLoading.save" :disabled="(!changeToSubmit && listPekerjaan.length==0)" 
                @click="handleDraft" icon="save">{{ "Draft" }}</a-button>
              <a-button v-if="!isEdit" :disabled="!changeToSubmit || isAnyOther" type="primary" :loading="btnLoading.save"
                @click="handleNew" icon="save">{{ "Submit" }}</a-button>
            </a-button-group>
          </div>
        </a-card>
      </a-col>
    </a-row>

    <a-modal v-model="modalTaskList.visible" centered :maskClosable="false" :footer="false" :width="isMobile ? '100%' : '70%'"
      @cancel="handleCloseTaskList">
      <template slot="title">
        <h3>Referensi Nirmala</h3>
      </template>
      <a-table :columns="modalTaskList.columns" :data-source="modalTaskList.listTask" bordered
        style="margin-top: 10px; flex: 1; height: 100%;" :pagination="modalTaskList.pagination"
        :loading="modalTaskList.loadingtable" size="small"
        :scroll="{ y: '60vh'}"
        key="tbltask" :rowKey="(record, index) => index">
        <span slot="no" slot-scope="value, item, index">
          {{ (modalTaskList.pagination.page - 1) * modalTaskList.pagination.pageSize + (index + 1) }}
        </span>
        <template slot="project" slot-scope="item">{{ item.project_nm }}</template>
        <template slot="subject" slot-scope="item">{{ item.subject }}</template>
        <template slot="kode" slot-scope="item">{{ item.id_wp }}</template>
      </a-table>
    </a-modal>
  </a-layout-content>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";
export default {
  name: "CreateAlokasi",
  props: ["id"],
  data() {
    return {
      basedData: [],
      basedData2: [],
      listPekerjaan: [],
      btnLoading: {
        add: false,
        save: false
      },
      changeToSubmit: false,
      totalPresentase: 0,
      pagination: {
        onChange: page => { },
        pageSize: 3,
        size: "small"
      },
      isEdit: false,
      editItem: [],
      saveLeave: false,
      deskripsi: "",
      countDesc: [],
      message: "",
      btnDisable: false,
      tlcperson: "",
      fortlc_readonly: false,
      getKaryawan: {},
      loadingkrywn: "loading",
      editingfortlc: false,
      kode_proyek: null,
      jenis_anggaran: null,
      mode: null,
      maxpercentage: 100,
      lblperiode: "",
      initialPeriode: null,
      modalTaskList: {
        visible: false,
        loadinglistTask: false,
        listTask: [],
        columns:[
          {
            title: 'No.',
            width: "50px",
            scopedSlots: { customRender: 'no' },
          },
          {
            title: 'Proyek',
            width: "100px",
            scopedSlots: { customRender: 'project' },
          },
          {
            title: 'Subjek',
            scopedSlots: { customRender: 'subject' },
          },
          {
            title: 'Kode',
            align: "center",
            width: "100px",
            scopedSlots: { customRender: 'kode' },
          },
        ],
        pagination: {
          page: 1,
          onChange: (page) => {
            this.modalTaskList.pagination.page = page;
          },
          pageSize: 50,
          size: "default"
        },
      },
      table_pekerjaan: {
        loading: false,
        columns: [
          {
            title: 'No',
            scopedSlots: { customRender: "no" },
            width: "50px",
            key: 'no',
            align: "right"
          },
          {
            title: 'Persentase',
            width: "100px",
            align: "right",
            key: 'persentase',
            scopedSlots: { customRender: "persentase" },
          },
          {
            title: 'Kode Proyek',
            key: 'kode_proyek',
            width: "150px",
            align: "center",
            scopedSlots: { customRender: "kode_proyek" },
          },
          {
            title: 'Deskripsi',
            key: 'deskripsi',
            scopedSlots: { customRender: "deskripsi" },
          },
          {
            title: 'Action',
            key: 'action',
            fixed: "right",
            width: "100px",
            scopedSlots: { customRender: "action" },
          },
        ],
        pagination: {
          page: 1,
          onChange: (page) => {
            this.table_pekerjaan.pagination.page = page;
          },
          pageSize: 5,
          size: "default"
        },
      },
      add_mode: {
        id: "",
        type: ""
      },
      loadingKodeProyek: false
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    if (localStorage.getItem("crtalks_")) {
      this.editingfortlc = localStorage.getItem("crtalks_") == 1 ? true : false;
    }

    if (this.id) {
      this.fetchEdit();
      this.mode = 'revised';
    } else {
      this.mode = 'create';
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.saveLeave) {
      const answer = window.confirm(
        "Data anda belum tersimpan, Apakah anda yakin untuk meninggalkan halaman ini?"
      );

      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  mounted() {
    this.fetchData(null);
    Event.$on("confirmMessageReturn", this.saveProcess);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.saveProcess);
  },
  watch: {
    totalPresentase() {
      if (this.isEdit) {
        this.changeToSubmit = false;
      } else {
        if (this.totalPresentase === 100) {
          this.changeToSubmit = true;
        } else {
          this.changeToSubmit = false;
        }
      }
      this.maxpercentage = 100 - this.totalPresentase
    }
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat"]),
    initialData() {
      return {
        periode: this.basedData.periode,
        presentase: 0
      };
    },
    projectCode() {
      let output = this.basedData.kode_project;

      // if (this.jenis_anggaran) {
      //   // this.kode_proyek = "";
      //   output = output.filter(
      //     obj =>
      //       obj.jns_anggaran_id
      //         .toLowerCase()
      //         .indexOf(this.jenis_anggaran.toLowerCase()) >= 0
      //   );
      // }
      return output;
    },
    // anggaranText() {
    //   let output = this.basedData.jenis_anggaran;

    //   if (this.jenis_anggaran) {
    //     output = output.filter(
    //       obj =>
    //         obj.value
    //           .toLowerCase()
    //           .indexOf(this.jenis_anggaran.toLowerCase()) >= 0
    //     );
    //   }
    //   return output[0].text;
    // },
    prefixLength: function () {
      let data = {};
      if (this.message) {
        if (this.message && this.message.length > 1000) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.btnDisable = true;
          data = {
            validateStatus: "error",
            errorMsg: "Deskripsi Tidak Boleh Lebih Dari 1000 Karakter"
          };
        } else {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.btnDisable = false;
          data = {
            validateStatus: "",
            errorMsg: ""
          };
        }
      }

      return data;
    },
    isDrafted(){
      return this.$route.path.includes('/draft/')
    },
    isAnyOther(){
      return this.listPekerjaan.length>0 ? (this.listPekerjaan.filter(item => item.kode_proyek=='OTHER')).length>0 : false
    }
  },
  methods: {
    moment,
    async fetchEdit() {
      this.listPekerjaan = []
      await axios({
        method: "get",
        url: this.$serviceUrl + "rekap_alokasi/data_rekap_alokasi",
        params: {
          tlc: this.getAuth.username,
          id_alokasi: this.id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.basedData2 = response.data;

          this.totalPresentase = 0
          response.data.detail.forEach((item) => {
            this.listPekerjaan.push({
              deskripsi: item.deskripsi,
              jenis_anggaran_id: null,
              jenis_anggaran: null,
              kode_proyek: item.kode_proyek,
              periode_lbl: item.periode,
              periode: response.data.header[0].periode_value ? moment(response.data.header[0].periode_value, "YYYY-MM") : null,
              persentase: item.persentase,
              id_alokasi_dtl: item.id_alokasi_dtl
            })
            this.totalPresentase += Number(item.persentase)
          })

          if (response.data.detail.length > 0) {
            this.initialPeriode = moment(response.data.header[0].periode_value, "YYYY-MM")
            this.changeperiode(this.initialPeriode)
          }

          this.saveLeave = true

        })
        .catch(err => {
          console.log(err.response);
        });
    },

    async fetchData() {
      const mstr = await axios.get(this.$serviceUrl + "rekap_alokasi/master", {
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        },
        params: {
          tlc: this.getAuth.username,
        }
      });
      const krywn = await axios.get(
        this.$serviceUrl + "rekap_alokasi/tlc_for_hrd_input",
        {
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey
          },
          params: {
            tlc: this.getAuth.username
          }
        }
      );

      this.loadingKodeProyek = true
      Promise.all([mstr, krywn]).then(response => {
        this.basedData = response[0].data;
        this.getKaryawan = response[1].data.list_tlc;
        this.loadingkrywn = "";
        this.loadingKodeProyek = false
      });
    },
    handleDraft(){
      this.$notification.success({
        message: "Sukses",
        description: "Data telah berhasil simpan draft!"
      });

      if (this.editingfortlc) {
        this.$router.push({ name: "hrd.mon.alokasi" });
      } else {
        this.$router.push({ name: "alokasiPekerjaan" });
      }
    },
    handleNew(mode) {
      this.add_mode.type = mode
      if (this.totalPresentase < 100 || this.isEdit) {
        this.form.validateFields((err, values) => {
          // console.log(err)
          // console.log(values)

          // if (!this.kode_proyek || !this.jenis_anggaran) {
          //   this.$notification.error({
          //     message: "Error",
          //     description: "Cek Kembali Kelengkapan Input Data Anda ... !"
          //   });
          //   return;
          // }
          // if (err || values.persentase < 1) {
          //   this.$notification.error({
          //     message: "Error",
          //     description: "Cek Kembali Kelengkapan Input Data Anda ... !"
          //   });
          //   return;
          // }
          if (!this.kode_proyek || this.kode_proyek == 'NOT_FOUND') {
            this.$notification.error({
              message: "Error",
              description: "Kode proyek harus diisi ... !"
            });
            return;
          }
          this.btnLoading.add = true;
          this.handleDescLength();
          if (this.message && this.message.length > 1000) {
            this.btnLoading.add = false;
            this.displayMessage("form-warning");
          } else {
            if (this.isEdit) {
              const index = this.listPekerjaan.indexOf(this.editItem);
              const newFileList = this.listPekerjaan.slice();
              newFileList.splice(index, 1);

              let tempTotal = 0;
              newFileList.forEach(data => {
                tempTotal = tempTotal + Number(data.persentase);
              });
              tempTotal = tempTotal + Number(values.persentase);

              if (tempTotal <= 100) {
                let post = new FormData();
                post.append("id_alokasi", this.id);
                post.append("tlc", this.editingfortlc ? this.tlcperson : this.getAuth.username);
                post.append("periode", moment(values.periode).format("YYYY-MM"));
                post.append("tlc_hrd", this.editingfortlc ? this.getAuth.username : null);
                post.append("proyek", this.kode_proyek);
                post.append("persentase", values.persentase);
                post.append("deskripsi", values.deskripsi ? values.deskripsi : "");

                let postJson = {
                  id_alokasi: this.id,
                  tlc: this.editingfortlc ? this.tlcperson : this.getAuth.username,
                  periode: moment(values.periode).format("YYYY-MM"),
                  tlc_hrd: this.editingfortlc ? this.getAuth.username : null,
                  proyek: this.kode_proyek,
                  persentase: values.persentase,
                  deskripsi: values.deskripsi ? values.deskripsi : ""
                }

                if(this.add_mode.type=="edit"){
                  post.append("id_alokasi_dtl", this.add_mode.id);
                  postJson['id_alokasi_dtl'] = this.add_mode.id;
                }

                this.btnLoading.add = true;
                this.btnLoading.save = true;
                axios({
                  method: this.add_mode.type=="new" ? "post" : "put",
                  url: this.$serviceUrl + "rekap_alokasi/draft",
                  processData: false,
                  data: this.add_mode.type=="new" ? post : postJson,
                  auth: {
                    username: this.getAuth.username,
                    password: this.getAuth.password
                  },
                  headers: {
                    "Content-Type": this.add_mode.type=="new" ? "multipart/form-data" : "application/json",
                    "X-API-KEY": this.getAuth.apikey
                  }
                })
                .then(() => {
                  let kdprjk = this.kode_proyek;
                  let anggaran = "";
                  // this.handleRemove(this.editItem);
                  this.totalPresentase = tempTotal;
                  this.tlcperson = this.editingfortlc ? values.fortlc : null;
                  this.listPekerjaan = [
                    ...this.listPekerjaan,
                    {
                      deskripsi: values.deskripsi ? values.deskripsi : "",
                      jenis_anggaran: null,
                      jenis_anggaran_id: null,
                      kode_proyek: kdprjk,
                      periode: values.periode,
                      periode_lbl: this.changeperiodeLbl(values.periode).replaceAll('~', '-'),
                      persentase: values.persentase
                    }
                  ];
                  if (tempTotal === 100) {
                    this.changeToSubmit = true;
                  }
                  this.$notification.success({
                    message: "Sukses",
                    description: "Data telah berhasil diubah!"
                  });
                  if (this.editingfortlc) {
                    let temptlc = values.fortlc;
                    this.form.resetFields();
                    this.kode_proyek = null;
                    this.jenis_anggaran = null;
                    this.form.setFieldsValue({
                      fortlc: temptlc,
                      periode: this.listPekerjaan[0].periode
                    });
                    this.fortlc_readonly = true;
                  } else {
                    this.form.resetFields();
                    this.form.setFieldsValue({
                      periode: this.listPekerjaan[0].periode
                    });
                    this.kode_proyek = null;
                    this.jenis_anggaran = null;
                  }

                  this.fetchEdit();

                  this.isEdit = false;
                  this.btnLoading.add = false;
                  this.btnLoading.save = false;
                })
                .catch(err => {
                  let response = Object.assign({}, err.response);
                  if (response.data.status == false && response.data.message) {
                    this.displayMessageValue("error-basic", response.data.message);
                  } else {
                    let responses = Object.assign({}, err.response.data);
                    this.displayMessageValue("error-other", responses);
                  }
                  this.btnLoading.add = false;
                  this.btnLoading.save = false;
                });          
              } else {
                this.$notification.error({
                  message: "Error",
                  description: "Total Persentase Melebihi Batas 100%!"
                });
                this.form.setFieldsValue({
                  persentase: this.maxpercentage
                });
                this.btnLoading.add = false;
              }
            } else {
              if (this.totalPresentase + values.persentase <= 100) {
                this.tlcperson = this.editingfortlc ? values.fortlc : null;

                let post = new FormData();
                post.append("tlc", this.editingfortlc ? this.tlcperson : this.getAuth.username);
                post.append("periode", moment(values.periode).format("YYYY-MM"));
                post.append("tlc_hrd", this.editingfortlc ? this.getAuth.username : null);
                post.append("proyek", this.kode_proyek);
                post.append("persentase", values.persentase);
                post.append("deskripsi", values.deskripsi ? values.deskripsi : "");

                let postJson = {
                  id_alokasi: this.id,
                  tlc: this.editingfortlc ? this.tlcperson : this.getAuth.username,
                  periode: moment(values.periode).format("YYYY-MM"),
                  tlc_hrd: this.editingfortlc ? this.getAuth.username : null,
                  proyek: this.kode_proyek,
                  persentase: values.persentase,
                  deskripsi: values.deskripsi ? values.deskripsi : ""
                }

                if(this.id) {
                  post.append("id_alokasi", this.id);
                  postJson['id_alokasi'] = this.id;
                }

                this.btnLoading.add = true;
                axios({
                method: "post",
                url: this.$serviceUrl + "rekap_alokasi/draft",
                processData: false,
                data: this.add_mode.type=="new" ? post : postJson,
                auth: {
                  username: this.getAuth.username,
                  password: this.getAuth.password
                },
                headers: {
                  "Content-Type": this.add_mode.type=="new" ? "multipart/form-data" : "application/json",
                  "X-API-KEY": this.getAuth.apikey
                }
              })
                .then(() => {
                  // this.totalPresentase = Number(this.totalPresentase) + Number(values.persentase);
                  this.listPekerjaan = [
                  ...this.listPekerjaan,
                  {
                    deskripsi: values.deskripsi ? values.deskripsi : "",
                    jenis_anggaran: "",
                    jenis_anggaran_id: null,
                    kode_proyek: this.kode_proyek,
                    periode: values.periode,
                    periode_lbl: this.changeperiodeLbl(values.periode).replaceAll('~', '-'),
                    persentase: values.persentase
                  }
                ];

                  if (this.editingfortlc) {
                    let temptlc = values.fortlc;
                    this.form.resetFields();
                    this.kode_proyek = null;
                    this.jenis_anggaran = null;
                    this.form.setFieldsValue({
                      fortlc: temptlc,
                      periode: this.listPekerjaan[0].periode
                    });
                    this.fortlc_readonly = true;
                  } else {
                    this.form.resetFields();
                    this.form.setFieldsValue({
                      periode: this.listPekerjaan[0].periode
                    });
                    this.kode_proyek = null;
                    this.jenis_anggaran = null;
                  }

                  this.fetchEdit();

                  this.btnLoading.add = false;

                  this.$notification.success({
                    message: "Sukses",
                    description: "Data telah berhasil diproses!"
                  });
                })
                .catch(err => {
                  let response = Object.assign({}, err.response);
                  if (response.data.status == false && response.data.message) {
                    this.displayMessageValue("error-basic", response.data.message);
                  } else {
                    let responses = Object.assign({}, err.response.data);
                    this.displayMessageValue("error-other", responses);
                  }
                  this.btnLoading.add = false;
                });                
              } else {
                this.$notification.error({
                  message: "Error",
                  description: "Total Persentase Melebihi Batas 100%!"
                });
                this.form.setFieldsValue({
                  persentase: this.maxpercentage
                });
                this.btnLoading.add = false;
              }
            }
          }
        });
      } else {
        this.confirmMessage("confirm-save");
      }
    },
    saveProcess() {
      let post = new FormData();
      this.btnLoading.save = true;
      let url = "";
      post.append(
        "tlc", this.editingfortlc ? this.tlcperson : this.getAuth.username);
      post.append(
        "periode", moment(this.listPekerjaan[0].periode).format("YYYY-MM"));
      post.append(
        "catatan", this.basedData2.header[0].catatan);

      if (this.mode == 'revised') {
        post.append("id_alokasi", this.id);
        post.append("id_alokasi_dtl", this.add_mode.id);
        this.listPekerjaan.forEach((data, index) => {
          post.append("proyek[" + index + "]", data.kode_proyek);
          post.append("persentase[" + index + "]", data.persentase);
          post.append(
            "deskripsi[" + index + "]",
            data.deskripsi ? data.deskripsi : ""
          );
        });

        url = this.isDrafted ? "rekap_alokasi" : "rekap_alokasi/edit_rekap";

      } else {
        post.append("tlc_hrd", this.editingfortlc ? this.getAuth.username : null);
        url = "rekap_alokasi"
        this.listPekerjaan.forEach((data, index) => {
          post.append("proyek[" + index + "]", data.kode_proyek);
          post.append("persentase[" + index + "]", data.persentase);
          post.append(
            "deskripsi[" + index + "]",
            data.deskripsi ? data.deskripsi : ""
          );
        });
      }
      axios({
        method: (this.isDrafted ? (this.add_mode.type=="new" || this.totalPresentase == 100 ? "post" : "put") : "post"),
        url: this.$serviceUrl + url,
        processData: false,
        data: post,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "Content-Type": "multipart/form-data",
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.saveLeave = true;
          Event.$emit("refreshNotification", true);
          if (this.mode == 'revised') {
            this.$notification.success({
              message: "Sukses",
              description: "Data telah berhasil update!"
            });
          } else {
            this.$notification.success({
              message: "Sukses",
              description: "Data telah berhasil disimpan!"
            });
          }


          this.btnLoading.save = false;
          if (this.editingfortlc) {
            this.$router.push({ name: "hrd.mon.alokasi" });
          } else {
            this.$router.push({ name: "alokasiPekerjaan" });
          }
        })
        .catch(err => {
          let response = Object.assign({}, err.response);
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-basic", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses);
          }
          this.btnLoading.save = false;
        });
    },
    handleRemove(item) {
      this.table_pekerjaan.loading = true
      axios({
        method: "delete",
        url: this.$serviceUrl + "rekap_alokasi/draft",
        processData: false,
        data: {
          id_alokasi: this.id,
          id_alokasi_dtl: item.id_alokasi_dtl,
          tlc: this.getAuth.username
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey
        }
      })
      .then(response => {
        const index = this.listPekerjaan.indexOf(item);
        const newFileList = this.listPekerjaan.slice();
        newFileList.splice(index, 1);

        let tempTotal = 0;
        newFileList.forEach(data => {
          tempTotal = tempTotal + Number(data.persentase);
        });
        this.totalPresentase = Number(tempTotal);

        this.listPekerjaan = newFileList;

        if (this.listPekerjaan.length === 0) {
          this.form.resetFields();
          this.kode_proyek = null;
          this.fortlc_readonly = false;
        }
        this.table_pekerjaan.loading = false
      })
      .catch(err => {
        let response = Object.assign({}, err.response);
        if (response.data.status == false && response.data.message) {
          this.displayMessageValue("error-basic", response.data.message);
        } else {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses);
        }
        this.table_pekerjaan.loading = false
      });
    },
    handleEdit(item) {
      this.add_mode.id = item.id_alokasi_dtl

      // console.log(item)

      // this.totalPresentase -=(parseInt(item.persentase));

      if (this.totalPresentase === 100) {
        this.maxpercentage = Number(item.persentase);
      } else {
        this.maxpercentage += Number(item.persentase);
      }
      this.kode_proyek = (item.kode_proyek=='OTHER' ? 'NOT_FOUND' : item.kode_proyek);
      this.isEdit = true;
      this.changeToSubmit = false;
      this.editItem = item;
      this.form.setFieldsValue({
        persentase: Number(item.persentase),
        periode: item.periode,
        deskripsi: item.kode_proyek=='OTHER' ? null : item.deskripsi
      });

      this.jenis_anggaran = null;
    },
    handleCancel() {
      if (this.totalPresentase === 100) {
        this.changeToSubmit = true;
      }
      this.isEdit = false;
      if (this.editingfortlc) {
        let temptlc = this.tlcperson;
        this.form.resetFields();
        this.kode_proyek = null;
        this.jenis_anggaran = null;
        this.form.setFieldsValue({
          fortlc: temptlc
        });
        this.fortlc_readonly = true;
      } else {
        this.form.resetFields();
        this.kode_proyek = null;
      }
    },
    handleDescLength() {
      this.message = this.form.getFieldValue("deskripsi");
    },
    handleFilterKaryawan(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    changeAnggaran(item) {
      this.kode_proyek = ""
    },
    changeperiode(val) {
      this.lblperiode = this.changeperiodeLbl(val)
      this.kode_proyek = null
      console.log(val)
      this.fetchData(moment(val).format('YYYY-MM'))
    },
    changeperiodeLbl(val) {
      return "28 " + moment(val).subtract(1, 'months').format("MMM YYYY") + " ~ " + "27 "
        + moment(val).format("MMM YYYY")
    },
    disabledDate(current) {
      let nowdate = moment().format("YYYY-MM") + "-27"
      // return current &&
      //   (current < moment(nowdate, "YYYY-MM-DD") && moment(current).format("MM") == moment(nowdate).format("MM")) ||
      //   moment(current).format("YYYY-MM") > moment(nowdate).format("YYYY-MM")
      //   ;
      return this.validateExistingData(current,nowdate)
    },
    handleViewTask(){
      const period_value = this.form.getFieldValue("periode");
      
      if(!period_value){
        this.displayMessageValue("error-basic", "Pilih Periode Terlebih Dahulu!");
        return;
      }

      this.modalTaskList.loadinglistTask = true
      axios({
        method: "GET",
        url: this.$serviceUrl + "rekap_alokasi/task",
        processData: false,
        params: {
          bulan: moment(period_value).locale('en').format('MMMM'),
          tahun: moment(period_value).format('YYYY'),
          tlc: this.getAuth.username
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey
        }
      })
      .then(response => {
        this.modalTaskList.listTask = response.data.task
        this.modalTaskList.loadinglistTask = false
        this.modalTaskList.visible = true
      })
      .catch(err => {
        let response = Object.assign({}, err.response);
        if (response.data.status == false && response.data.message) {
          this.displayMessageValue("error-basic", response.data.message);
        } else {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses);
        }
        this.modalTaskList.loadinglistTask = false
      });
    },
    handleCloseTaskList(){
      this.modalTaskList.visible = false
    },
    validateExistingData(current, now){
      return (_.findIndex(this.basedData.periode_draft, s => _.some(s, o => {return o == moment(current).format('MM-YYYY')}))>=0) || 
        moment(now) >= moment().add(1, 'M') ||
        moment(current).format("MM") == moment(now).format("MM") ||
        moment(current).format("YYYY-MM") > moment(now).format("YYYY-MM")
    }
  }
};
</script>

<style lang="less">
.vs__dropdown-toggle {
  height: 35px;
}
.vs__dropdown-option {
  text-wrap: auto !important;
}
</style>
